import React from 'react';

const context = React.createContext();

export { context as default };

export const withPageBlocker = (Component) => (props) =>
    <context.Consumer>{(blocker) => <Component {...props} blocker={blocker} />}</context.Consumer>
